import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Divider, 
  Link, 
  Stack, 
  Typography, 
  Grid
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import LoginNavbar from './LoginNavbar';
import { DEFAULT_THEME, type ThemeColors } from '../../constants/themeDefaults';

interface LoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // Use the default theme for styling
  const theme = DEFAULT_THEME;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box sx={{ 
      minHeight: '100vh',
      bgcolor: theme.backgroundColor,
      display: 'flex',
      flexDirection: 'column'
    }}>
      <LoginNavbar />
      <Box component="main" sx={{ flex: 1 }}>
        {children}
      </Box>

      {/* Simplified footer with only legal links */}
      <Box 
        component="footer" 
        sx={{ 
          py: 4,
          bgcolor: theme.subtleAccent,
          color: theme.textColor,
          borderTop: '1px solid',
          borderColor: theme.borderColor,
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" gutterBottom fontWeight={600} textAlign="center">
                MindShare
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }} textAlign="center">
                Your appointments, your way.
                Always available, even offline.
              </Typography>
            </Grid>
            
            <Grid item xs={12}>
              <Stack direction="row" spacing={3} justifyContent="center">
                <Link component={RouterLink} to="/privacy" color="text.secondary" underline="hover">
                  Privacy Policy
                </Link>
                <Link component={RouterLink} to="/terms" color="text.secondary" underline="hover">
                  Terms of Service
                </Link>
                <Link component={RouterLink} to="/credits" color="text.secondary" underline="hover">
                  Credits
                </Link>
              </Stack>
            </Grid>
          </Grid>
          
          <Divider sx={{ my: 3 }} />
          
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} MindShare. All rights reserved.
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default LoginLayout; 